import React, { Component } from "react";
import { connect } from "react-redux";
import { deleteCallEvent, deleteCallEvents, updateCallEvent, setResetActiveTab } from "../actions/call";
import {
	getOutgoingCalls,
	getIncomingCalls,
	getAuotoDialerCalls
} from "../actions/getCalls";
import {
	Tab,
	Row,
	Col,
	Nav,
	NavItem,
	NavDropdown,
	MenuItem
} from "react-bootstrap";
import SetBusinessOutcome from "./modals/setBusinessOutcome";
import RescheduleCall from "./modals/RescheduleCall";
import AssignToAnotherService from "./modals/AssignToAnotherService";
import BusinessOutcomeAlert from "./modals/BusinessOutcomeAlert";
import SetTagsModal from "./modals/setTagsModal";
import { filterUrl } from "../utils/utils";
import Iframe from "./Components/Iframe";
import "./tabs.css";
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";
import "../agent/Styles/highContrast.css";

const scrollAmount = 300;
let tabScrollElement, scrollRightInterval, scrollLeftInterval;
let tabScrollElementPadding = 30;

let entered_urls = {};

class TabMenu extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isShow: false,
			web_url: "http://www.techwarehouz.com/donate",
			load_url: "http://www.techwarehouz.com/donate",
			activeTab: this.props.agentConfig.initialUrls
				? this.props.agentConfig.initialUrls[0].url_id
				: "first",
			initialUrls: this.props.agentConfig.initialUrls || [],
			callEvents: [],
			omniData: null,
			callEventsMore: [],
			scheduleDate: "",
			currentPostion: 0,
			tabsScrollWidth: 600,
			currentEvent: {
				data: {}
			},
			innerWidth: window.innerWidth,
			tabsWithoutBusinessOutcome: []
		};
		this.handleClick = this.handleClick.bind(this);
	}

	componentDidMount() {
		this.initializeEnteredUrls(this.state.initialUrls);
		tabScrollElement = document.querySelector("#userTabs");
		window.addEventListener("resize", this.isOverflown);
		//tabScrollElement = document.querySelector('#userTabs');
		if (tabScrollElement.addEventListener) {
			tabScrollElement.addEventListener(
				"mousewheel",
				this.scrollHorizontally,
				false
			);
			tabScrollElement.addEventListener(
				"DOMMouseScroll",
				this.scrollHorizontally,
				false
			);
		} else {
			tabScrollElement.attachEvent("onmousewheel", this.scrollHorizontally);
		}

	}

	componentWillReceiveProps(nextProps) {
		if (
			JSON.stringify(nextProps.omniData) !== JSON.stringify(this.props.omniData)
		) {
			this.setState({ omniData: nextProps.omniData });
            const url =
              nextProps.omniData &&
              nextProps.omniData.data &&
              nextProps.omniData.data.url
                ? nextProps.omniData.data.url
                : null;
			if(url) {
				this.setState({ activeTab: url });
			}
		}

		if (
			nextProps.callEvents.length !== this.props.callEvents.length &&
			nextProps.callEvents.length > 0
		) {
			const isNewCall =
				nextProps.callEvents.length > this.props.callEvents.length;
			this.setState(
				{
					activeTab: `${
						nextProps.callEvents[nextProps.callEvents.length - 1].data.id
						}`
				},
				() => {
					//this.updateDimensions();
					this.isOverflown(isNewCall);
				}
			);
		}

		if (nextProps.missedCalls !== this.props.missedCalls) {
			const latest_call =
				nextProps.missedCalls[nextProps.missedCalls.length - 1];
			if (latest_call) {
				const data = this.props.callEvents.find(
					item => item.data.id == latest_call.data.id
				);
				if (data) {
					this.props.deleteCallEvent(data);
				}
				this.setState({
					activeTab: this.state.initialUrls[0].url_id
				});
			}
		}
		if (
			nextProps.agentConfig !== this.props.agentConfig &&
			nextProps.agentConfig.initialUrls
		) {
			console.log('nextProps.agentConfig.initialUrls', nextProps.agentConfig.initialUrls);
			this.setState({
				initialUrls: nextProps.agentConfig.initialUrls,
				
				activeTab: this.props.agentConfig.initialUrls
				? this.props.agentConfig.initialUrls[0].url_id
				: "first",
			});

			this.initializeEnteredUrls(nextProps.agentConfig.initialUrls);
		}

		if (nextProps.reActivateTab.data.id) {
			if (nextProps.callEvents.length > 0) {
				this.setState(
					{
						activeTab: `${nextProps.reActivateTab.data.id}`
					},
					() => {
						this.scrollTo(
							document.getElementById(
								`tabs-with-dropdown-tab-${nextProps.reActivateTab.data.id}`
							)
						);
					}
				);
			}
		}

		if (nextProps.fullScreen !== this.props.fullScreen) {
			//this.checkForTabSpace(nextProps.fullScreen);
			this.isOverflown();
		}

		if(nextProps.resetActiveTab) {
			this.props.setResetActiveTab(false);
			this.setState({
				activeTab: this.state.initialUrls[0].url_id
			});
		}
	}

	initializeEnteredUrls = (initialUrls) => {
		entered_urls = {};

		if (initialUrls) {
			initialUrls.forEach(item => {
				entered_urls[item.url_id] = item.url;
			});
		}
	}

	// scrolls to element (tab)
	scrollTo = element => {
		if (this.state.tabsOverflow) {
			const rect = element.getBoundingClientRect();
			let currentPostion = 0;
			let doScroll = false;
			if (rect.left + rect.width > tabScrollElement.clientWidth) {
				doScroll = true;
				currentPostion =
					this.state.currentPostion +
					(rect.left + rect.width - tabScrollElement.clientWidth) -
					45;
			} else if (rect.left < 0) {
				doScroll = true;
				currentPostion = this.state.currentPostion + rect.left - 45;
			}
			if (doScroll) {
				this.setState(
					{
						currentPostion,
						scrollStart: currentPostion === 0,
						scrollEnd: currentPostion === tabScrollElement.scrollWidth
					},
					() => {
						tabScrollElement.scroll({
							left: this.state.currentPostion,
							behavior: "smooth"
						});
					}
				);
			}
		}
	};
	// making horizontal scroll on vertical scroll
	scrollHorizontally = e => {
		e = window.event || e;
		e.preventDefault();
		const delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
		tabScrollElement.scrollLeft -= delta * 40;
		this.updateScrollState(tabScrollElement);
	};
	// updates boolean or start and end scroll position
	updateScrollState = el => {
		this.setState({
			currentPostion: el.scrollLeft,
			scrollEnd: el.clientWidth + el.scrollLeft >= el.scrollWidth,
			scrollStart: el.scrollLeft === 0,
			tabsScrollWidth: tabScrollElement.scrollWidth
		});
	};
	// checks if element is overflown
	isOverflown = newCall => {
		this.setState(
			{
				tabsOverflow:
					tabScrollElement.scrollWidth > tabScrollElement.clientWidth
			},
			() => {
				if (newCall) {
					const currentPostion =
						tabScrollElement.scrollWidth - tabScrollElement.clientWidth;
					tabScrollElement.scroll({
						left: currentPostion,
						behavior: "smooth"
					});
					this.setState({
						currentPostion,
						tabsScrollWidth: tabScrollElement.scrollWidth,
						scrollStart: false,
						scrollEnd: true
					});
				} else {
					this.updateScrollState(tabScrollElement);
				}
			}
		);
	};
	// scrolls to left when arrow button is clicked
	scrollLeft = () => {
		if (!this.state.scrollStart) {
			let currentPostion = this.state.currentPostion - scrollAmount;
			if (currentPostion < 0) {
				currentPostion = 0;
			}
			this.setState(
				{
					currentPostion,
					scrollStart: currentPostion === 0,
					scrollEnd: currentPostion === tabScrollElement.scrollWidth
				},
				() => {
					tabScrollElement.scroll({
						left: this.state.currentPostion,
						behavior: "smooth"
					});
				}
			);
		}
	};
	// scrolls to right when arrow button is clicked
	scrollRight = () => {
		if (!this.state.scrollEnd) {
			let currentPostion = this.state.currentPostion + scrollAmount;
			if (
				currentPostion + tabScrollElement.clientWidth >
				tabScrollElement.scrollWidth
			) {
				currentPostion =
					this.state.currentPostion +
					(tabScrollElement.scrollWidth -
						(tabScrollElement.clientWidth + (currentPostion - scrollAmount)));
			}
			this.setState(
				{
					currentPostion,
					scrollStart: currentPostion === 0,
					scrollEnd:
						currentPostion + tabScrollElement.clientWidth ===
						tabScrollElement.scrollWidth
				},
				() => {
					tabScrollElement.scroll({
						left: this.state.currentPostion,
						behavior: "smooth"
					});
				}
			);
		}
	};

	handleLeftScrollStart = () => {
		scrollLeftInterval = setInterval(() => {
			this.scrollLeft();
		}, 200);
	};

	handleRightScrollStart = () => {
		scrollRightInterval = setInterval(() => {
			this.scrollRight();
		}, 200);
	};

	handleLeftScrollStop = () => {
		clearInterval(scrollLeftInterval);
	};

	handleRightScrollStop = () => {
		clearInterval(scrollRightInterval);
	};

	handleTabKeyPress = e => {
		e.preventDefault();
		let k = e.keyCode;
		if (k >= 37 && k <= 40) {
			return false;
		}
	};

	close = key => {
		this.setState({ [key]: false });
	};
	// opens modal according to key.
	open = (key, event) => {
		this.setState(
			{
				CallId: event.data.id,
				phoneNumber: event.tag.includes("outgoing")
					? event.data.to
					: event.data.from,
				serviceId: event.data.service_id,
				end_business_id: event.data.end_business_id,
				schedule_date: event.data.schedule_date || "",
				currentEvent: event,
				listDetailId: event.data.list_detail_id !== undefined
				? event.data.list_detail_id
				: 0
			},
			() => {
				this.setState({
					[key]: true
				});
			}
		);
	};

	// handleUrlChange = (e) => {
	// 	this.setState({[e.target.name]: e.target.value});
	// }

	// looks for enter key press to update url
	checkEnter = e => {
		if (e.key === "Enter") {
			let url_id = e.target.id;
			let entered_url = document.getElementsByName(`web_url${url_id}`)[0].value;
			entered_urls[url_id] = entered_url;
			this.changeURL(entered_url, url_id);
		}
	};
	// updates active tab
	onSelect = activeTab => {
		this.setState(
			{
				activeTab
			},
			() => {
				this.scrollTo(
					document.getElementById(`tabs-with-dropdown-tab-${activeTab}`)
				);
			}
		);
	};

	// changes tab and create object with empty data object
	changeTab = e => {
		let currentEvent = {
			data: {}
		};
		this.setState({
			activeTab: e.target.id,
			currentEvent
		});
	};
	// closes tab
	closeTab = e => {
		e.stopPropagation();

		const data = this.props.callEvents.find(
			item => item.data.id === e.target.id
		);

		this.closeTabs([data]);
	};

	closeTabs = (tabs) => {
		let tabsWithoutBusinessOutcome = [];
		let tabsToClose = [];

		tabs.forEach(tab => {
			if(tab.data.mandatory_end_of_business === '1') {
				if (tab.data.end_business_id == undefined || tab.data.end_business_id == '') {
					tabsWithoutBusinessOutcome.push(tab);
				}
				else {
					tabsToClose.push(tab);
				}
			}
			else {
				tabsToClose.push(tab);
			}
		});

		if(tabsWithoutBusinessOutcome.length !== tabs.length) {
			this.setState({ activeTab: this.state.initialUrls[0].url_id }, () => {
					this.props.deleteCallEvents(tabsToClose);
				});
		}

		if(tabsWithoutBusinessOutcome.length > 0) {
			this.openBusinessOutcomeAlertModal(tabsWithoutBusinessOutcome);
		}
	};

	openBusinessOutcomeAlertModal = (tabsWithoutBusinessOutcome) => {
		this.setState({ tabsWithoutBusinessOutcome: tabsWithoutBusinessOutcome, showBusinessOutcomeAlertModal: true });
	}

	closeBusinessOutcomeAlertModal = (resetActiveTab = false) => {
		const url =
              this.props.omniData &&
              this.props.omniData.data &&
              this.props.omniData.data.url
                ? this.props.omniData.data.url
                : null;

		if(url) {
			this.setState({ showBusinessOutcomeAlertModal: false, activeTab: resetActiveTab? url : this.state.activeTab });
		} else {
			this.setState({ showBusinessOutcomeAlertModal: false, activeTab: resetActiveTab? this.state.initialUrls[0].url_id : this.state.activeTab });
		}
		// this.setState({ showBusinessOutcomeAlertModal: false, activeTab: resetActiveTab? this.state.initialUrls[0].url_id : this.state.activeTab });
	}

	tabContextMenuHandler = (e) => {
		this.rightClickedTabId = e.target.getAttribute("data-key");
		e.preventDefault();
		e.stopPropagation();

		let left = e.clientX;
		let top = e.clientY;
		this.customMenu.style.left = left + "px";
		this.customMenu.style.top = top + "px";
		this.customMenu.style.display = "block";

		window.addEventListener("click", this.removeCustomContextMenu);
		window.addEventListener("contextmenu", this.removeCustomContextMenu);
	};

	removeCustomContextMenu = (e) => {
		window.removeEventListener("click", this.removeCustomContextMenu);
		window.removeEventListener("contextmenu", this.removeCustomContextMenu);
		this.customMenu.style.display = "none";
	};

	closeAllTabs = (e) => {
		if (this.rightClickedTabId === "")
			return;

		this.closeTabs(this.props.callEvents);

		this.rightClickedTabId = "";
	};

	closeOtherTabs = (e) => {
		if (this.rightClickedTabId === "" || this.props.callEvents.length === 1)
			return;

		const data = this.props.callEvents.filter(
			item => item.data.id !== this.rightClickedTabId
		);

		this.closeTabs(data);

		this.rightClickedTabId = "";
	};

	closeCurrentTab = (e) => {
		if (this.rightClickedTabId === "")
			return;

		const data = this.props.callEvents.find(
			item => item.data.id === this.rightClickedTabId
		);

		this.closeTabs([data]);

		this.rightClickedTabId = "";
	};

	// gets url that needs to be displayed on input
	getUrl = url => {
		return filterUrl(url);
	};

	/**
	 * refresh calls for side panesl. and updates data for current opened tab
	 * @param  {string} name
	 * @param  {string} value
	 * @param  {string} name2
	 * @param  {string} value2
	 */
	refreshCalls = (name, value, name2, value2) => {
		setTimeout(() => {
			this.props.getIncomingCalls();
			this.props.getOutgoingCalls();
			this.props.getAuotoDialerCalls();
		}, 5000);
		if (name != "service_name") {
			const data = this.state.currentEvent;
			data.data[name] = value;
			if (name2) {
				data.data[name2] = value2;
			}
			this.props.updateCallEvent(data);
		}
	};

	outgoingServiceCb = (callId, end_business_id) => {
		this.refreshCalls("end_business_id", end_business_id);
	};

	rescheduleCallCb = (CallId, scheduleDate, schedule_service) => {
		this.refreshCalls("schedule_date", scheduleDate, "schedule_service", schedule_service);
	};

	handleClick() {
		this.setState(function (prevState) {
			return { isShow: !prevState.isShow };
		});
	}

	/**
	 * updates url for the opened tab
	 * @param  {object} e
	 * @param  {string} url_id
	 */
	changeURL = (entered_url, url_id) => {
		const url_filter =
			entered_url.includes("http://") || entered_url.includes("https://")
				? entered_url
				: `http://${entered_url}`;

		document.getElementById(`webpage_iframe${url_id}`).src = url_filter;
		// if(this.state.web_url === this.state.load_url) {
		// 	document.getElementById('webpage_iframe').src = document.getElementById('webpage_iframe').src;
		// }else{
		// 	this.setState({load_url: url, web_url: url});
		// }
	};

	reloadUrl = (e, url_id) => {
		if (url_id in entered_urls) {
			this.changeURL(entered_urls[url_id], url_id);
			document.getElementsByName(`web_url${url_id}`)[0].value = entered_urls[url_id];
		}
	}

	render() {
		const { initialUrls, tabsOverflow, scrollStart, scrollEnd, omniData } = this.state;
		const { callEvents, translations, selectedLanguage, listDetailId } = this.props;
		return (
			<Tab.Container
				id="tabs-with-dropdown"
				defaultActiveKey={initialUrls.length > 0 ? initialUrls[0].url_id : ""}
				onSelect={this.onSelect}
				activeKey={this.state.activeTab}
			>
				<Row className="clearfix">
					<Col sm={12}>
						{tabsOverflow && (
							<div
								className={`leftButton ${
									scrollStart ? "arrowBtnDisabled" : ""
									}`}
								onClick={this.scrollLeft}
								onMouseDown={this.handleLeftScrollStart}
								onMouseUp={this.handleLeftScrollStop}
							>
								<span className="icon icon-arrow-left" />
							</div>
						)}
						<div
							id={`userTabs${this.props.theme}`}
							tabIndex="0"
							onKeyDown={this.handleTabKeyPress}
							onKeyPress={this.handleTabKeyPress}
							onKeyUp={this.handleTabKeyPress}
							className={`${tabsOverflow ? "overflown" : ""}`}
						>
							<Nav className={`nav-tabs${this.props.theme}`}
							 style={{ flexGrow: 100 }}>
								 {omniData && omniData.data && omniData.data.url ?
								    <NavItem
										key={omniData.data.url}
										eventKey={omniData.data.url}
										onClick={this.changeTab}
									>
										<span>
										    <span className="icon icon-chat" style={{margin:"0px 5px"}} /> 
										    {translations.omni[selectedLanguage]}
									    </span>
									</NavItem>
							    : null}
								{initialUrls &&
									initialUrls.map(item => (
										<NavItem
											key={item.url_id}
											eventKey={item.url_id}
											onClick={this.changeTab}
										>
											<span className="icon icon-network" /> {item.url_name}
										</NavItem>
									))}
								{callEvents.map(event => (
									<NavItem
										key={`${event.data.id}`}
										eventKey={`${event.data.id}`}
										data-key={`${event.data.id}`}
										onClick={this.changeTab}
										className="tabItem"
										onContextMenu={this.tabContextMenuHandler}
									>
										<span
											className={`icon ${
												event.tag.includes("outgoing")
													? "icon-arrow-up"
													: "icon-arrow-down"
												}`}
										/>
										{event.tag.includes("outgoing")
											? event.data.to
											: event.data.from}
										{/* {event.data.service_name || this.props.agentInfo.calling_service_name ? ` (${event.data.service_name || this.props.agentInfo.calling_service_name})` : ''} */}
										{event.data.service_name
											? ` (${event.data.service_name})`
											: ""}
										<span
											className="icon icon-circle-with-cross close-tab"
											id={event.data.id}
											onClick={this.closeTab}
										/>
									</NavItem>
								))}
							</Nav>
							<div type="context" className="context-menu" id="menu" ref={(customMenu) => this.customMenu = customMenu}>
								<span className="context-menu-item" onClick={this.closeAllTabs}>{translations.closeAllTabs[selectedLanguage]}</span>
								<span className="context-menu-item" onClick={this.closeOtherTabs}>{translations.clostOtherTabs[selectedLanguage]}</span>
								<span className="context-menu-item" onClick={this.closeCurrentTab}>{translations.closeTab[selectedLanguage]}</span>
							</div>
						</div>
						{tabsOverflow && (
							<div
								className={`rightButton ${scrollEnd ? "arrowBtnDisabled" : ""}`}
								onClick={this.scrollRight}
								onMouseDown={this.handleRightScrollStart}
								onMouseUp={this.handleRightScrollStop}
							>
								<span className="icon icon-arrow-right" />
							</div>
						)}
					</Col>
					<Col sm={12}>
						<Tab.Content
							animation
							className={`tab-content content-pane${this.props.theme} pos-r-content-content`}>
							{omniData && omniData.data && omniData.data.url ?
								<Tab.Pane eventKey={omniData.data.url} key={omniData.data.url}>
									<Iframe
										item={omniData.data}
										hasId
										errorMsg={translations.serviceUrlError[selectedLanguage]}
									/>
								</Tab.Pane>
							: null}
							{initialUrls &&
								initialUrls.map(item => (
									<Tab.Pane eventKey={item.url_id} key={item.url_id}>
										<div className="flextable" style={{margin: "10px 0px"}}>
											<div className="flextable-item flextable-primary">
												<div className="input-with-icon w-full">
													<input
														type="text"
														name={`web_url${item.url_id}`}
														id={item.url_id}
														defaultValue={this.getUrl(item.url)}
														onKeyPress={this.checkEnter}
														//onChange={this.handleUrlChange}
														placeholder={
															translations.browserPlaceholder[selectedLanguage]
														}
														className={`form-control${this.props.theme} input-smm${this.props.theme}`}
													/>
													<span className="icon icon-globe" />
												</div>
											</div>
											<div className="flextable-item">
												<div className="btn-group">
													<button
														type="button"
														id={item.url_id}
														onClick={(e) => this.reloadUrl(e, item.url_id)}
														className={`btn btn-primary-outline btn-sm btn-primary-outline${this.props.theme}`}
													>
														<span className="icon icon-cycle" />
													</button>
												</div>
											</div>
										</div>
										<Iframe
											item={item}
											hasId
											errorMsg={translations.serviceUrlError[selectedLanguage]}
										/>
									</Tab.Pane>
								))}
							{callEvents.map(event => (
								<Tab.Pane
									eventKey={`${event.data.id}`}
									key={`${event.data.id}`}
								>
									<div className="text-center" style={{ marginBottom: "1rem", marginTop: "10px" }}>
										<button
											type="button"
											className={`btn btn-primary-outline btn-sm btn-primary-outline${this.props.theme}`}
											onClick={() =>
												this.open("showRescheduleCallModal", event)
											}
										>
											<span className="icon icon-clock" />{" "}
											{translations.rescheduleCall[selectedLanguage]}
										</button>
										<button
											type="button"
											className={`btn btn-primary-outline btn-sm btn-primary-outline${this.props.theme}`}
											onClick={() =>
												this.open("showSetBusinessOutcomeModal", event)
											}
										>
											<span className="icon icon-archive" />{" "}
											{translations.businessOutcome[selectedLanguage]}
										</button>
										<button
											type="button"
											className={`btn btn-primary-outline btn-sm btn-primary-outline${this.props.theme}`}
											onClick={() =>
												this.open("showAssignToAnotherServiceModal", event)
											}
										>
											<span className="icon icon-popup" />{" "}
											{translations.assignToAnotherService[selectedLanguage]}
										</button>
										<button
											type="button"
											className={`btn btn-primary-outline btn-sm btn-primary-outline${this.props.theme}`}
											onClick={() =>
												this.open("showTagsModal", event)
											}
										>
											<span className="icon  icon-price-tag" />{" "}
											{translations.tagList[selectedLanguage]}
										</button>
									</div>
									{/* {!event.data.url && <div className="text-left-space">
	                  <pre>{JSON.stringify(event.data, null, 2) }</pre>
	                </div>} */}
									{event.data.url && (
										// <iframe
										// 	title={event.data.url}
										// 	className="content-pane-cont free-top iframe_section"
										// 	src={this.getUrl(event.data.url)}
										// />
										<Iframe
											item={event.data}
											errorMsg={translations.serviceUrlError[selectedLanguage]}
										/>
									)}
								</Tab.Pane>
							))}
						</Tab.Content>
						<RescheduleCall
							serviceId={this.state.serviceId}
							CallId={this.state.CallId}
							phoneNumber={this.state.phoneNumber}
							scheduleDate={this.state.currentEvent.data.schedule_date || ""}
							scheduleService={this.state.currentEvent.data.schedule_service || ""}
							showModal={this.state.showRescheduleCallModal}
							rescheduleCallCb={this.rescheduleCallCb}
							listDetailId={this.state.listDetailId}
							getCalls={this.refreshCalls}
							handleClose={() => this.close("showRescheduleCallModal")}
						/>
						<SetBusinessOutcome
							serviceId={this.state.serviceId}
							CallId={this.state.CallId}
							endBusinessId={this.state.end_business_id}
							showModal={this.state.showSetBusinessOutcomeModal}
							handleClose={() => this.close("showSetBusinessOutcomeModal")}
							outgoingServiceCb={this.outgoingServiceCb}
						/>
						<SetTagsModal
							serviceId={this.state.serviceId}
							CallId={this.state.CallId}
							showModal={this.state.showTagsModal}
							handleClose={() => this.close("showTagsModal")}
							getCalls={this.refreshCalls}
						/>
						<AssignToAnotherService
							CallId={this.state.CallId}
							showModal={this.state.showAssignToAnotherServiceModal}
							handleClose={() => this.close("showAssignToAnotherServiceModal")}
							getCalls={this.refreshCalls}
						/>
						<BusinessOutcomeAlert
							showModal={this.state.showBusinessOutcomeAlertModal}
							handleClose={(resetActiveTab) => this.closeBusinessOutcomeAlertModal(resetActiveTab)}
							tabsWithoutBusinessOutcome={this.state.tabsWithoutBusinessOutcome}
						/>

					</Col>
				</Row>
			</Tab.Container>
		);
	}
}

function mapStateToProps(state) {
	return {
		agentConfig: state.agentConfig,
		agentInfo: state.agentInfo,
		callEvents: state.callEvents.events,
		reActivateTab: state.callEvents.reActivateTab,
		missedCalls: state.callEvents.missedCalls,
		fullScreen: state.callEvents.fullScreen,
		modifiedCall: state.callEvents.modifiedCall,
		modifiedCallTime: state.callEvents.modifiedCallTime,
		resetActiveTab: state.callEvents.resetActiveTab,
		translations: state.languages.translations,
		selectedLanguage: state.languages.selectedLanguage,
		darkMode: state.common.darkMode,
		theme: state.common.theme,
		omniData: state.common.omniData,
	};
}

const mapDispatchToProps = {
	deleteCallEvent,
	deleteCallEvents,
	getOutgoingCalls,
	getIncomingCalls,
	getAuotoDialerCalls,
	updateCallEvent,
	setResetActiveTab,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(TabMenu);



// WEBPACK FOOTER //
// ./src/agent/tabs.js